export default {
  marginT10: {
    marginTop: 10
  },
  marginT20: {
    marginTop: 20
  },
  marginT30: {
    marginTop: 30
  },
  marginT40: {
    marginTop: 40
  },
  marginB10: {
    marginBottom: 10
  },
  marginB20: {
    marginBottom: 20
  },
  marginB30: {
    marginBottom: 30
  },
  marginB40: {
    marginBottom: 40
  },
}
